import { Button, DialogActions, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SettingsDialogViewProps } from './SettingsDialog';

export default function SettingsDialogWelcome({ next }: SettingsDialogViewProps): React.JSX.Element {
  const { t } = useTranslation(['common', 'settings']);

  return (
    <>
      <DialogTitle>
        <Typography>
          {t('settings:complete_your_profile')}
        </Typography>
        <Typography>
          {t('settings:complete_your_profile_description')}
        </Typography>
      </DialogTitle>
      <DialogActions>
        <Button
          onClick={() => next()}
          variant="contained"
          sx={{
            flex: 1,
            mb: 2,
          }}
        >
          {t('common:start')}
        </Button>
      </DialogActions>
    </>

  );
}
